import { atom, useAtomValue } from 'jotai';
import { useHydrateAtoms } from 'jotai/utils';

const imagesAtom = atom({});

export function useStoreImages(images: { [imgKey: string]: { blurDataURL: string; src: string } }) {
  useHydrateAtoms([[imagesAtom, images]]);
}

export function useStaticImage(
  imageKey: string,
  fallbackSrc: string
): { src: string; blurDataURL: string; placeholder?: 'blur' } {
  const staticImages = useAtomValue(imagesAtom);
  return staticImages[imageKey]
    ? { ...staticImages[imageKey], placeholder: 'blur' }
    : { src: fallbackSrc, blurDataURL: null };
}
